import { render, staticRenderFns } from "./AdminProductEditPictures.vue?vue&type=template&id=4240332a&"
import script from "./AdminProductEditPictures.vue?vue&type=script&lang=js&"
export * from "./AdminProductEditPictures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports